




import { Component, Vue, Prop, Mixins } from 'vue-property-decorator';
import widgetCommon from './widgetCommon';
import widget from './widgetInRecord';
import { newRecursion } from '@/utils/common';
@Component({
	components: {},
})
export default class extends Vue {
	@Prop({ default: () => ({}) }) public item!: any;
	@Prop({ default: () => ({}) }) public form!: any;
	private get field() {
		return newRecursion(this.item) || {};
	}
	private get fieldForm() {
		return { [this.item.displayField]: this.form[this.item.businessId] };
	}
	private beforeCreate() {
		(this.$options.components as any).widget = widget;
	}
}
